if (!customElements.get('mu-collection-card')) {
    class muunCollectionCard extends HTMLElement {
        constructor() {
            super();
            this.slider = this.querySelector('.muun-collection-card__slider');
            this.slides = this.querySelectorAll('.muun-collection-card__slide');
            this.prevBtn = this.querySelector('.muun-collection-card__prev');
            this.nextBtn = this.querySelector('.muun-collection-card__next');
            this.currentIndex = 0;
            this.showNext = this.showNext.bind(this);
            this.showPrev = this.showPrev.bind(this);
        }
        connectedCallback() {
            // Start and stop the autoplay video depending on visibility
            const videos = this.querySelectorAll('video[autoplay]');
            const observer = new IntersectionObserver(
                (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;

                    if (entry.isIntersecting) {
                    if (video.paused || video.ended) {
                        video.currentTime = 0;
                        video.play().catch((err) => {
                        console.warn('Autoplay blocked:', err);
                        });
                    }
                    } else {
                    video.pause();
                    }
                });
                },
                {
                threshold: 0.5,
                }
            );
            videos.forEach((video) => {
                observer.observe(video);
            });
            // Slider functionality
            this.nextBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.showNext();
            });
            this.prevBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.showPrev();
            });
            // Resize slider on window resize
            window.addEventListener('resize', () => {
                if (window.innerWidth >= 768) {
                this.updateSlider();
                } else {
                this.slider.style.transform = '';
                }
            });
        }
        updateSlider() {
            const targetSlide = this.slides[this.currentIndex];
            const sliderRect = this.slider.getBoundingClientRect();
            const targetRect = targetSlide.getBoundingClientRect();
            const slideOffset = targetRect.left - sliderRect.left;
            this.slider.style.transform = `translateX(-${slideOffset}px)`;
            this.prevBtn.style.opacity = this.currentIndex === 0 ? 0.25 : 1;
            this.nextBtn.style.opacity = this.currentIndex === this.slides.length - 1 ? 0.25 : 1;
        }
        showNext() {
            if (this.currentIndex < this.slides.length - 1) {
                this.currentIndex++;
                this.updateSlider();
            }
        }
        showPrev() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.updateSlider();
            }
        }
    }
    customElements.define('mu-collection-card', muunCollectionCard);
}